import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/Navigation-logo/PaymeDaily-new-logo.png";
import educationThumb from "../assets/insights/blog1.webp";
import caseStudyThumb from "../assets/insights/dailypaycard.webp";
import resourceThumb from "../assets/insights/blog3.webp";
import phoneThumb from "../assets/insights/blog4.webp";

const navItems = ["Employers", "Solutions", "Our Partners", "Resources"];

const platformItems = [
  {
    title: "DailyPay Platform",
    body: "Industry-leading On-Demand Pay.",
    icon: "platform",
    active: true,
    path: "/earned-wage-access-platform",
  },
  {
    title: "Small Business",
    body: "On-Demand Pay for businesses under 500 employees.",
    icon: "business",
    badge: "New",
  },
  {
    title: "DailyPay Visa Prepaid Card",
    body: "Reach even more employees with On-Demand Pay.",
    icon: "card",
  },
  {
    title: "Cycle",
    body: "Easily disburse off-cycle pay.",
    icon: "cycle",
  },
  {
    title: "Tips",
    body: "Real-time digital tips access.",
    icon: "tips",
  },
  {
    title: "Perks",
    body: "Employ financial benefits with curated discounts and deals on life's biggest expenses",
    icon: "perks",
    badge: "New",
  },
];

const initiatives = [
  {
    title: "On-Demand Pay for Employees",
    body: "Employees can access their pay on their schedule instead of waiting for payday.",
  },
  {
    title: "Implement Earned Wage Access",
    body: "Earned Wage Access improves employee retention and recruitment.",
  },
  {
    title: "Reduce Employee Turnover",
    body: "How much does turnover cost your company?",
  },
  {
    title: "Improve Employee Financial Wellness",
    body: "How does employee financial wellness impact your bottom line?",
  },
  {
    title: "Improve Employee Retention",
    body: "Experience cost savings and higher workplace morale.",
  },
  {
    title: "Increase Employee Engagement",
    body: "Boost productivity and revenue.",
  },
];

const resources = [
  {
    type: "Turnover Calculator",
    title: "How much is turnover costing your company?",
    calculator: true,
  },
  {
    type: "Whitepaper",
    title: "DailyPay Tops List as #1 Adopted Financial Wellness Benefit",
    image: educationThumb,
  },
  {
    type: "Thought Leadership",
    title: "How Can an On-Demand Pay Platform Help Your Business?",
    image: phoneThumb,
  },
];

const generalMenus = {
  Employers: {
    overviewTitle: "DailyPay Overview",
    overviewBody:
      "On-Demand Pay - also known as earned wage access - gives employees access to their earned pay before payday. DailyPay is your key to improving recruitment, retention, motivation and productivity.",
    quickLinks: [
      {
        title: "Why DailyPay",
        body: "When your employees have greater control over their finances, your business wins too.",
      },
      {
        title: "Clients",
        body: "DailyPay partners with industry leaders across HCM and payroll for a seamless experience.",
      },
      {
        title: "Integrations",
        body: "DailyPay integrates with 180+ HCM, payroll and time management systems to deliver industry-leading EWA to millions of users.",
      },
    ],
    listTitle: "Industries",
    listHeading: "Overview",
    listBody:
      "While each industry has to deal with unique economic factors and different customer bases, one constant is the employee. Learn how to support them with On-Demand Pay.",
    listItems: [
      // "Hospitals & Healthcare",
       {
    name: "Hospitals & Healthcare",
    path: "/emp_hospitalhealthcare",
  },
  { 
  name: "Grocers & Supermarkets",
      path:"/emp_grocerssupermarket"
  },
      {name:"Retail",
       path:"emp_retails" 
      },
      {name:"Call & Contact Centers",
        path:"/emp_callandcontact"
      },
      {
       name:"Restaurants & QSR",
       path: "/emp_restaurantqsr"
      },

      { name:"Manufacturing",
        path:"/emp_manufacturing"
      },
      "Travel & Hospitality",
      "Public Sector",
      "Franchise",
    ],
    featured: [
      {
        type: "Education Series",
        title: "All You Need to Know About On-Demand Pay",
        thumb: "education",
      },
      {
        type: "Case Study",
        title: "DailyPay: The Benefit Duracell's Employees Asked for by Name",
        thumb: "duracell",
      },
      {
        type: "Case Study",
        title: "Offering DailyPay Helped Adecco Improve Retention in the Staffing Industry",
        thumb: "adecco",
      },
    ],
  },
  "Our Partners": {
    overviewTitle: "Partners Overview",
    overviewBody:
      "Work with PayMeDaily to deliver a trusted On-Demand Pay experience through HCM, payroll, and financial ecosystem partnerships.",
    quickLinks: [
      {
        title: "Partner Overview",
        body: "See how we collaborate with technology and channel partners.",
      },
      {
        title: "Integration Partners",
        body: "Pre-built integrations make implementation faster and easier.",
      },
      {
        title: "Financial Institutions",
        body: "Create modern disbursement experiences through embedded finance.",
      },
    ],
    listTitle: "Partner Types",
    listHeading: "Explore Partners",
    listBody:
      "Explore the partner ecosystem that helps PayMeDaily scale across employers and employees.",
    listItems: [
      "Human Capital Management",
      "Workforce Management",
      "Payroll Providers",
      "Banks & Financial Institutions",
      "HR Technology",
      "Consulting Firms",
      "Rewards Platforms",
      "Customer Experience",
    ],
    featured: [
      {
        type: "Featured Partner",
        title: "PayMeDaily for Workday customers",
        image: caseStudyThumb,
      },
      {
        type: "Whitepaper",
        title: "Why modern payroll experiences are now a talent differentiator",
        image: resourceThumb,
      },
      {
        type: "Resource",
        title: "PayMeDaily Built In",
        image: educationThumb,
      },
    ],
  },
  Resources: {
    overviewTitle: "Resource Center",
    overviewBody:
      "Browse thought leadership, case studies, and employer education that explain how On-Demand Pay works and why teams choose PayMeDaily.",
    quickLinks: [
      {
        title: "Case Studies",
        body: "Real employer stories and retention outcomes.",
      },
      {
        title: "Guides & Webinars",
        body: "Educational content for decision-makers and HR leaders.",
      },
      {
        title: "Blog",
        body: "Fresh perspectives on payroll, engagement, and workforce trends.",
      },
    ],
    listTitle: "Browse By",
    listHeading: "Content Types",
    listBody:
      "Find the content type that best fits your research, from quick reads to deep-dive resources.",
    listItems: [
      "Education Series",
      "Case Studies",
      "Whitepapers",
      "Webinars",
      "Guides",
      "Podcasts",
      "Research",
      "Customer Stories",
    ],
    featured: [
      {
        type: "Case Study",
        title: "Offering PayMeDaily helped Adecco improve retention in staffing",
        image: caseStudyThumb,
      },
      {
        type: "Blog",
        title: "How employee engagement impacts your bottom line",
        image: resourceThumb,
      },
      {
        type: "Blog",
        title: "How much is turnover costing your company?",
        image: educationThumb,
      },
    ],
  },
};

function ChevronIcon({ open }) {
  return (
    <svg className={`pmd-chevron ${open ? "is-open" : ""}`} viewBox="0 0 20 20" aria-hidden="true">
      <path d="M5.4 7.6 10 12.1l4.6-4.5" />
    </svg>
  );
}

function SearchIcon() {
  return (
    <svg className="pmd-search-icon" viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="10.8" cy="10.8" r="6.8" />
      <path d="m16.2 16.2 4 4" />
    </svg>
  );
}

function CloseIcon() {
  return (
    <svg className="pmd-mobile-close-icon" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M5 5l14 14M19 5 5 19" />
    </svg>
  );
}

function MenuIcon() {
  return (
    <svg className="pmd-mobile-menu-icon" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M4 6h16M4 12h16M4 18h16" />
    </svg>
  );
}

function ExternalIcon() {
  return (
    <svg className="pmd-external-icon" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M14 5h5v5" />
      <path d="m10 14 9-9" />
      <path d="M19 14v5H5V5h5" />
    </svg>
  );
}

function MobileResourceCard({ resource }) {
  return (
    <a className="pmd-mobile-resource-card" href="/">
      <div className="pmd-mobile-resource-image">
        {resource.calculator ? (
          <CalculatorThumb />
        ) : resource.thumb === "education" ? (
          <EducationMenuThumb />
        ) : resource.thumb ? (
          <CaseStudyThumb partner={resource.thumb} />
        ) : (
          <img src={resource.image} alt={resource.title} />
        )}
      </div>
      <div>
        <span>{resource.type}</span>
        <strong>{resource.title}</strong>
      </div>
    </a>
  );
}

function MobileWorkdayCard() {
  return (
    <a className="pmd-mobile-workday-card" href="/">
      <span className="pmd-featured-partner-image">
        <img src={logo} alt="PayMeDaily Workday partner" />
        <span className="pmd-workday-badges">
          <span className="pmd-workday-badge pmd-workday-innovation">
            <strong>Innovation<br />Partner</strong>
            <em>workday.</em>
          </span>
          <span className="pmd-workday-badge">
            <strong>Certified<br />Integration</strong>
            <em>workday.</em>
          </span>
        </span>
      </span>
      <strong>PayMeDaily: The Preferred On-Demand Pay Solution for Workday Customers</strong>
    </a>
  );
}

function MobilePanelLink({ activeLink, children, className = "", href = "/", id, onSelect }) {
  const activeClass = activeLink === id ? "is-orange" : "";
  const classes = [className, activeClass].filter(Boolean).join(" ");

  return (
    <Link className={classes || undefined} to={href} onClick={() => onSelect(id)}>
      {children}
    </Link>
  );
}

function MobileAccordionPanel({ activeLink, item, onSelect }) {
  if (item === "Employers") {
    return (
      <div className="pmd-mobile-panel">
        <MobilePanelLink activeLink={activeLink} href="/emp_overview" id="employers-overview" onSelect={onSelect}>DailyPay Overview</MobilePanelLink>
        <MobilePanelLink activeLink={activeLink} href="/emp_whyus" id="employers-why" onSelect={onSelect}>Why DailyPay</MobilePanelLink>
        <MobilePanelLink activeLink={activeLink} href="/emp_clients" id="employers-clients" onSelect={onSelect}>Clients</MobilePanelLink>
        <MobilePanelLink activeLink={activeLink} href="/emp_integration" id="employers-integrations" onSelect={onSelect}>Integrations</MobilePanelLink>

        <div className="pmd-mobile-title">Industries</div>
        <MobilePanelLink activeLink={activeLink} href="/emp_indusoverview" id="industries-overview" onSelect={onSelect}>Overview</MobilePanelLink>
        <MobilePanelLink activeLink={activeLink} href="/emp_hospitalhealthcare" id="industries-healthcare" onSelect={onSelect}>Hospitals &amp; Healthcare</MobilePanelLink>
        <MobilePanelLink activeLink={activeLink} href="/emp_grocerssupermarket" id="industries-grocers" onSelect={onSelect}>Grocers &amp; Supermarkets</MobilePanelLink>
        <MobilePanelLink activeLink={activeLink} href="/emp_retails" id="industries-retail" onSelect={onSelect}>Retail</MobilePanelLink>
      </div>
    );
  }

  if (item === "Solutions") {
    return (
      <div className="pmd-mobile-panel">
        <div className="pmd-mobile-title">Platform &amp; Features</div>
        <div className="pmd-mobile-feature-card">
          {platformItems.slice(0, 2).map((platform) => (
            <MobilePanelLink
              activeLink={activeLink}
              className="pmd-mobile-icon-row"
              href={platform.path || "/"}
              id={`platform-${platform.title}`}
              key={platform.title}
              onSelect={onSelect}
            >
              <PlatformIcon type={platform.icon} />
              <span>{platform.title}</span>
              {platform.badge && <b>{platform.badge}</b>}
            </MobilePanelLink>
          ))}
        </div>
        {platformItems.slice(2).map((platform) => (
          <MobilePanelLink
            activeLink={activeLink}
            className="pmd-mobile-icon-row"
            href={platform.path || "/"}
            id={`platform-${platform.title}`}
            key={platform.title}
            onSelect={onSelect}
          >
            <PlatformIcon type={platform.icon} />
            <span>{platform.title}</span>
            {platform.badge && <b>{platform.badge}</b>}
          </MobilePanelLink>
        ))}

        <div className="pmd-mobile-title">By Initiative</div>
        {initiatives.map((initiative) => (
          <MobilePanelLink activeLink={activeLink} id={`initiative-${initiative.title}`} key={initiative.title} onSelect={onSelect}>
            {initiative.title}
          </MobilePanelLink>
        ))}

        <div className="pmd-mobile-featured pmd-mobile-featured-flush">
          <div className="pmd-mobile-title">Featured Resources</div>
          {resources.map((resource) => (
            <MobileResourceCard resource={resource} key={resource.title} />
          ))}
        </div>
      </div>
    );
  }

  if (item === "Our Partners") {
    return (
      <div className="pmd-mobile-panel">
        <MobilePanelLink activeLink={activeLink} id="partners-overview" onSelect={onSelect}>Partners Overview</MobilePanelLink>
        <MobilePanelLink activeLink={activeLink} id="partners-hcm" onSelect={onSelect}>Human Capital Management</MobilePanelLink>
        <MobilePanelLink activeLink={activeLink} id="partners-workforce" onSelect={onSelect}>Workforce Management</MobilePanelLink>
        <MobilePanelLink activeLink={activeLink} id="partners-banks" onSelect={onSelect}>Banks &amp; Financial Institutions</MobilePanelLink>
        <MobilePanelLink activeLink={activeLink} id="partners-built-in" onSelect={onSelect}>
          PayMeDaily Built In <sup>TM</sup> <b>New</b>
        </MobilePanelLink>

        <div className="pmd-mobile-featured">
          <div className="pmd-mobile-title">Featured Partner</div>
          <MobileWorkdayCard />
        </div>
      </div>
    );
  }

  return (
    <div className="pmd-mobile-panel">
      <div className="pmd-mobile-title">Learn</div>
      <MobilePanelLink activeLink={activeLink} id="resources-blog" onSelect={onSelect}>Blog</MobilePanelLink>
      <MobilePanelLink activeLink={activeLink} id="resources-case-studies" onSelect={onSelect}>Case Studies</MobilePanelLink>
      <MobilePanelLink activeLink={activeLink} id="resources-guides" onSelect={onSelect}>Guides</MobilePanelLink>
      <MobilePanelLink activeLink={activeLink} id="resources-podcasts" onSelect={onSelect}>Podcasts</MobilePanelLink>
      <MobilePanelLink activeLink={activeLink} id="resources-webinars" onSelect={onSelect}>Webinars</MobilePanelLink>
      <MobilePanelLink activeLink={activeLink} className="pmd-mobile-icon-row" id="resources-education" onSelect={onSelect}>
        <PlatformIcon type="platform" />
        <span>On-Demand Pay Education Series</span>
      </MobilePanelLink>
      <MobilePanelLink activeLink={activeLink} className="pmd-mobile-icon-row" id="resources-certification" onSelect={onSelect}>
        <PlatformIcon type="perks" />
        <span>DailyPay Certification Program</span>
      </MobilePanelLink>

      <div className="pmd-mobile-title">Company</div>
      <MobilePanelLink activeLink={activeLink} id="company-about" onSelect={onSelect}>About Us</MobilePanelLink>
      <MobilePanelLink activeLink={activeLink} id="company-impact" onSelect={onSelect}>Impact</MobilePanelLink>
      <MobilePanelLink activeLink={activeLink} id="company-awards" onSelect={onSelect}>Awards &amp; Recognition</MobilePanelLink>
      <MobilePanelLink activeLink={activeLink} id="company-press" onSelect={onSelect}>Press Center</MobilePanelLink>
      <MobilePanelLink activeLink={activeLink} id="company-resource-center" onSelect={onSelect}>Resource Center &gt;</MobilePanelLink>

      <div className="pmd-mobile-featured">
        <div className="pmd-mobile-title">Featured Resources</div>
        {generalMenus.Resources.featured.map((resource) => (
          <MobileResourceCard resource={resource} key={resource.title} />
        ))}
      </div>
    </div>
  );
}

function MobileMenu({ activeItem, activeLink, onLinkSelect, onToggle, onClose }) {
  return (
    <div className="pmd-mobile-backdrop">
      <aside className="pmd-mobile-menu" aria-label="Mobile navigation">
        <div className="pmd-mobile-menu-head">
          <Link className="pmd-mobile-drawer-logo" to="/" onClick={onClose}>
            <img src={logo} alt="PayMeDaily" />
          </Link>
          <button className="pmd-mobile-close" type="button" aria-label="Close menu" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>

        <div className="pmd-mobile-menu-scroll">
          {navItems.map((item) => (
            <section className="pmd-mobile-section" key={item}>
              <button
                className={`pmd-mobile-accordion ${activeItem === item ? "is-open" : ""}`}
                type="button"
                onClick={() => onToggle(item)}
              >
                <span>{item}</span>
                <ChevronIcon open={activeItem === item} />
              </button>
              {activeItem === item && (
                <MobileAccordionPanel
                  activeLink={activeLink}
                  item={item}
                  onSelect={onLinkSelect}
                />
              )}
            </section>
          ))}

          <div className="pmd-mobile-employee-box">
            <strong>For Employees</strong>
            <p>Ready to see your available balance?</p>
            <div>
              <a href="/">Log In</a>
              <a href="/">Sign Up</a>
            </div>
          </div>
        </div>

        <div className="pmd-mobile-demo-bar">
          <a href="/">Get a Demo</a>
        </div>
      </aside>
    </div>
  );
}

function PlatformIcon({ type }) {
  const orange = "#ff4b14";
  const common = {
    className: "pmd-platform-icon",
    viewBox: "0 0 32 32",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2.1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
  };

  if (type === "platform") {
    return (
      <svg {...common}>
        <rect x="4.5" y="7.5" width="23" height="18" rx="3" />
        <path d="M11 17.2c1.4-3.9 4.2-3.9 5.2-1.5.9-1.4 2.4-2.1 4.8.1" stroke={orange} strokeWidth="3.1" />
      </svg>
    );
  }

  if (type === "business") {
    return (
      <svg {...common}>
        <path d="M5.5 14.5h21v11h-21z" />
        <path d="M8 14.5v-4h16v4" />
        <path d="M5.5 18.8c2 .8 4 .8 6 0 2 .9 4 .9 6 0 2 .9 4 .9 6 0 1 .4 2 .6 3 .6" />
        <path d="M20.5 25.5h4" stroke={orange} strokeWidth="3" />
      </svg>
    );
  }

  if (type === "card") {
    return (
      <svg {...common}>
        <rect x="4.5" y="5.5" width="18" height="21" rx="2.5" />
        <rect x="10.5" y="11.5" width="17" height="15" rx="2.5" />
        <path d="M10.5 17h17" />
        <path d="M14.5 22h5.5" stroke={orange} strokeWidth="2.8" />
      </svg>
    );
  }

  if (type === "cycle") {
    return (
      <svg {...common}>
        <rect x="4.5" y="7.5" width="23" height="20" rx="2.5" />
        <path d="M4.5 13h23" />
        <path d="M10 4.5v5" />
        <path d="M22 4.5v5" />
        <circle cx="11.5" cy="20.5" r="1.7" fill={orange} stroke="none" />
        <circle cx="20.5" cy="20.5" r="1.7" fill={orange} stroke="none" />
      </svg>
    );
  }

  if (type === "tips") {
    return (
      <svg {...common}>
        <path d="M10.5 13.5a5.5 5.5 0 0 1 11 0c0 2.3-1.2 3.5-2.6 4.8-.8.8-1.1 1.5-1.1 2.4h-3.6c0-.9-.3-1.6-1.1-2.4-1.4-1.3-2.6-2.5-2.6-4.8Z" />
        <path d="M13.5 24h5" />
        <path d="M14.5 27h3" />
        <circle cx="16" cy="14" r="1.9" fill={orange} stroke="none" />
      </svg>
    );
  }

  return (
    <svg {...common}>
      <path d="M7 16c1.8 1.5 3.5 3.5 4.7 6" />
      <path d="M25 16c-1.8 1.5-3.5 3.5-4.7 6" />
      <path d="M12 11c.4 4 1.8 7.4 4 10.2" />
      <path d="M20 11c-.4 4-1.8 7.4-4 10.2" />
      <path d="M16 21.2v5.3" />
      <circle cx="21.8" cy="9.5" r="2" fill={orange} stroke="none" />
    </svg>
  );
}

function CalculatorThumb() {
  return (
    <div className="pmd-calculator-thumb">
      <div className="pmd-calculator-paper">
        <span className="pmd-calc-title" />
        {[0, 1, 2].map((item) => (
          <span className="pmd-calc-row" key={item}>
            <i />
            <b />
          </span>
        ))}
        <span className="pmd-calc-foot" />
      </div>
    </div>
  );
}

function EducationMenuThumb() {
  return (
    <div className="pmd-education-thumb">
      <span className="pmd-edu-phone" />
      <span className="pmd-edu-face" />
      <span className="pmd-edu-body" />
      <span className="pmd-edu-card" />
    </div>
  );
}

function CaseStudyThumb({ partner }) {
  return (
    <div className="pmd-case-thumb">
      <div className="pmd-case-top">{partner}</div>
      <div className="pmd-case-title">
        Case
        <br />
        Study<span>.</span>
      </div>
    </div>
  );
}

function ResourceCard({ resource }) {
  return (
    <a className="pmd-resource-card" href="/">
      <div className="pmd-resource-image">
        {resource.calculator ? (
          <CalculatorThumb />
        ) : resource.thumb === "education" ? (
          <EducationMenuThumb />
        ) : resource.thumb ? (
          <CaseStudyThumb partner={resource.thumb} />
        ) : (
          <img src={resource.image} alt={resource.title} />
        )}
      </div>
      <div className="pmd-resource-copy">
        <div className="pmd-resource-type">{resource.type}</div>
        <div className="pmd-resource-title">{resource.title}</div>
      </div>
    </a>
  );
}

function SolutionsMenu({ onMouseEnter, onMouseLeave }) {
  return (
    <div className="pmd-mega" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <div className="pmd-mega-inner">
        <section className="pmd-left-col">
          <div className="pmd-column-title">Platform &amp; Features</div>

          <div className="pmd-feature-card">
            {platformItems.slice(0, 2).map((item) => (
              <Link className="pmd-platform-row" to={item.path || "/"} key={item.title}>
                <div className="pmd-row-heading">
                  <PlatformIcon type={item.icon} />
                  <span className={item.active ? "is-active" : ""}>{item.title}</span>
                  {item.badge && <b>{item.badge}</b>}
                </div>
                <p>{item.body}</p>
              </Link>
            ))}
          </div>

          <div className="pmd-platform-list">
            {platformItems.slice(2).map((item) => (
              <Link className="pmd-platform-row" to={item.path || "/"} key={item.title}>
                <div className="pmd-row-heading">
                  <PlatformIcon type={item.icon} />
                  <span>{item.title}</span>
                  {item.badge && <b>{item.badge}</b>}
                </div>
                <p>{item.body}</p>
              </Link>
            ))}
          </div>
        </section>

        <section className="pmd-middle-col">
          <div className="pmd-column-title">By Initiative</div>
          <div className="pmd-initiative-list">
            {initiatives.map((item) => (
              <a className="pmd-initiative" href="/" key={item.title}>
                <strong>{item.title}</strong>
                <span>{item.body}</span>
              </a>
            ))}
          </div>
        </section>

        <aside className="pmd-resource-col">
          <div className="pmd-column-title">Featured Resources</div>
          <div className="pmd-resource-list">
            {resources.map((resource) => (
              <ResourceCard resource={resource} key={resource.title} />
            ))}
          </div>
        </aside>

        <div className="pmd-integrations">
          <a href="/">Explore all Integrations <span>&gt;</span></a>
          <p>Our On-Demand Pay solution integrates with payroll and time management systems.</p>
        </div>
      </div>
    </div>
  );
}

function GeneralMenu({ menu, onMouseEnter, onMouseLeave, onClose }) {
  if (!menu) return null;

  return (
    <div className="pmd-mega" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <div className="pmd-general-inner">
        <section className="pmd-general-overview">
          <div className="pmd-mega-close-line">
            <Link className="pmd-mega-title" to="/emp_overview" onClick={onClose}>
              {menu.overviewTitle}
            </Link>
            
          </div>
          <p>{menu.overviewBody}</p>

       <div className="pmd-quick-links">
  {menu.quickLinks.map((item) => (
<Link
  key={item.title}
  to={
    item.title?.trim().toLowerCase() === "why dailypay"
      ? "/emp_whyus"
      : item.title?.trim().toLowerCase() === "clients"
      ? "/emp_clients"
      : item.title?.trim().toLowerCase() === "integrations"
      ? "/emp_integration"
      : item.title?.trim().toLowerCase() === "Overview"
      ? "/emp_indusoverview"
      : "/"
  }
>
      <strong>{item.title}</strong>
      <span>{item.body}</span>
    </Link>

    
  ))}
</div>
        </section>

        

        <section className="pmd-general-list">
          <div className="pmd-column-title">{menu.listTitle}</div>
<Link
  to="/emp_indusoverview"
  onClick={onClose}
  className="
    inline-block
    group
    cursor-pointer
  "
>
  <h3
    className="
      transition-all
      duration-300
      group-hover:text-[#5a0b0b]
    "
  >
    {menu.listHeading}
  </h3>
</Link>         
 <p>{menu.listBody}</p>

       <div className="pmd-general-grid">
  {menu.listItems.map((item, index) => (
    <Link
      key={index}
      to={
        typeof item === "object"
          ? item.path
          : `/${item
              .toLowerCase()
              .replace(/&/g, "and")
              .replace(/[^a-z0-9]+/g, "-")
              .replace(/(^-|-$)/g, "")}`
      }
      onClick={onClose}
    >
      {typeof item === "object" ? item.name : item}
    </Link>
  ))}
</div>
        </section>

        <aside className="pmd-resource-col pmd-general-resources">
          <div className="pmd-column-title">Featured Resources</div>
          <div className="pmd-resource-list">
            {menu.featured.map((resource) => (
              <ResourceCard resource={resource} key={resource.title} />
            ))}
          </div>
        </aside>

        <div className="pmd-general-cta">
          <span>See the DailyPay difference</span>
          <button type="button">Let's Talk</button>
        </div>
      </div>
    </div>
  );
}

function ResourceLearnIcon({ type }) {
  if (type === "education") {
    return (
      <svg className="pmd-resource-learn-icon" viewBox="0 0 32 32" aria-hidden="true">
        <circle cx="7.2" cy="9.1" r="2.1" />
        <path d="M4.2 15.6c0-2 1.3-3.4 3-3.4s3 1.4 3 3.4" />
        <path d="M5.2 16.4v7.3" />
        <path d="M9.2 16.4v7.3" />
        <path d="M13.6 7h10.8v13.6H13.6z" />
        <path d="M13.6 10.8h-2.8" />
        <path d="M17.3 20.6v4.1" />
        <path d="M14.5 24.7h5.6" />
        <path className="pmd-icon-accent-fill" d="m24.5 4.8.8 1.7 1.9.2-1.4 1.3.4 1.9-1.7-.9-1.7.9.4-1.9-1.4-1.3 1.9-.2.8-1.7Z" />
      </svg>
    );
  }

  return (
    <svg className="pmd-resource-learn-icon" viewBox="0 0 32 32" aria-hidden="true">
      <path className="pmd-icon-accent-fill" d="m8 5.1.6 1.3 1.4.2-1 1 .2 1.4L8 8.3 6.8 9l.2-1.4-1-1 1.4-.2L8 5.1Z" />
      <path d="m16 2.9.7 1.5 1.7.3-1.2 1.2.3 1.7-1.5-.8-1.5.8.3-1.7-1.2-1.2 1.7-.3.7-1.5Z" />
      <path d="m24 5.1.6 1.3 1.4.2-1 1 .2 1.4-1.2-.7-1.2.7.2-1.4-1-1 1.4-.2.6-1.3Z" />
      <circle cx="16" cy="16.5" r="5" />
      <circle className="pmd-icon-accent-fill" cx="16" cy="16.5" r="2.1" />
      <path d="M12.6 20.4 9.7 28l6.3-3.2 6.3 3.2-2.9-7.6" />
    </svg>
  );
}

function PaycheckThumb() {
  return (
    <span className="pmd-paycheck-thumb" aria-hidden="true">
      <span />
      <i />
      <b />
    </span>
  );
}

function ResourcesMenu({ onMouseEnter, onMouseLeave }) {
  const learnLinks = ["Blog", "Case Studies", "Guides", "Podcasts", "Webinars"];
  const companyLinks = ["About Us", "Impact", "Awards & Recognition", "Press Center"];
  const featureCards = [
    {
      type: "Turnover Calculator",
      title: "How much is turnover costing your company?",
      thumb: "calculator",
    },
    {
      type: "Blog",
      title: "How Employee Engagement Impacts Your Bottom Line",
      image: phoneThumb,
    },
    {
      type: "Blog",
      title: "What is a Paycheck Advance and Why You Should Avoid Them",
      thumb: "paycheck",
    },
  ];

  return (
    <div className="pmd-mega" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <div className="pmd-resources-inner">
        <section className="pmd-resources-learn">
          <div className="pmd-column-title">Learn</div>
          <div className="pmd-resources-learn-grid">
            <nav className="pmd-resources-link-list" aria-label="Learn resources">
              {learnLinks.map((item) => (
                <a href="/" key={item}>{item}</a>
              ))}
            </nav>

            <div className="pmd-resources-programs">
              <a className="pmd-resource-program" href="/">
                <ResourceLearnIcon type="education" />
                <span>
                  <strong>On-Demand Pay Education Series</strong>
                  <em>Learn how to get started with On-Demand Pay.</em>
                </span>
              </a>
              <a className="pmd-resource-program" href="/">
                <ResourceLearnIcon type="certification" />
                <span>
                  <strong>PayMeDaily Certification Program</strong>
                  <em>Free courses to earn EWA certification &amp; SHRM credit.</em>
                </span>
              </a>
            </div>
          </div>
        </section>

        <section className="pmd-resources-company">
          <div className="pmd-column-title">Company</div>
          <nav className="pmd-resources-link-list" aria-label="Company resources">
            {companyLinks.map((item) => (
              <a href="/" key={item}>{item}</a>
            ))}
          </nav>
        </section>

        <aside className="pmd-resources-featured">
          <div className="pmd-column-title">Featured Resources</div>
          <div className="pmd-resources-card-list">
            {featureCards.map((resource) => (
              <a className="pmd-resources-card" href="/" key={resource.title}>
                <span className="pmd-resources-card-image">
                  {resource.thumb === "calculator" ? (
                    <CalculatorThumb />
                  ) : resource.thumb === "paycheck" ? (
                    <PaycheckThumb />
                  ) : (
                    <img src={resource.image} alt="" />
                  )}
                </span>
                <span className="pmd-resources-card-copy">
                  <em>{resource.type}</em>
                  <strong>{resource.title}</strong>
                </span>
              </a>
            ))}
          </div>
        </aside>

        <div className="pmd-resources-cta">
          <a href="/">Resource Center <span>&gt;</span></a>
          <p>Our library of On-Demand Pay thought leadership.</p>
        </div>
      </div>
    </div>
  );
}

function PartnersMenu({ onMouseEnter, onMouseLeave }) {
  return (
    <div className="pmd-mega" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <div className="pmd-partners-inner">
        <section className="pmd-partners-left">
          <a className="pmd-partners-overview" href="/">
            <h3>Partners Overview</h3>
            <p>
              Work with PayMeDaily to implement the most trusted solutions in On-Demand Pay that
              work best for your clients and their employees.
            </p>
          </a>

          <div className="pmd-partner-links">
            <a href="/">Human Capital Management</a>
            <a href="/">Workforce Management</a>
            <a href="/">Banks &amp; Financial Institutions</a>
          </div>
        </section>

        <section className="pmd-partners-middle">
          <a className="pmd-built-in" href="/">
            <strong>
              PayMeDaily Built In<sup>TM</sup> <b>New</b>
            </strong>
            <span>The easiest way for HCM partners to integrate EWA into their platform.</span>
          </a>
        </section>

        <aside className="pmd-partners-featured">
          <div className="pmd-column-title">Featured Partner</div>
          <a className="pmd-featured-partner-card" href="/">
            <span className="pmd-featured-partner-image">
              <img src={logo} alt="PayMeDaily Workday partner" />
              <i aria-hidden="true" />
              <span className="pmd-workday-badges" aria-hidden="true">
                <span className="pmd-workday-badge pmd-workday-innovation">
                  <strong>Innovation<br />Partner</strong>
                  <em>workday.</em>
                </span>
                <span className="pmd-workday-badge">
                  <strong>Certified<br />Integration</strong>
                  <em>workday.</em>
                </span>
              </span>
            </span>
            <strong>
              PayMeDaily: The Preferred On-Demand Pay Solution for Workday Customers
            </strong>
          </a>
        </aside>
      </div>
    </div>
  );
}

function Navbar() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [mobileActiveItem, setMobileActiveItem] = useState("");
  const [mobileActiveLink, setMobileActiveLink] = useState("");
  const [employeeBarVisible, setEmployeeBarVisible] = useState(true);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [activeDropdown, setActiveDropdown] = useState("");
  const closeTimer = useRef(null);

  const cancelClose = () => {
    if (closeTimer.current) {
      clearTimeout(closeTimer.current);
      closeTimer.current = null;
    }
  };

  const openDropdown = (item) => {
    cancelClose();
    setActiveDropdown(item);
  };

  const scheduleClose = () => {
    cancelClose();
    closeTimer.current = setTimeout(() => {
      setActiveDropdown("");
      closeTimer.current = null;
    }, 140);
  };

  const closeMobileMenu = () => {
    setMenuOpen(false);
    setMobileActiveItem("");
  };

  const handleMobileLinkSelect = (id) => {
    setMobileActiveLink(id);
    closeMobileMenu();
  };

  useEffect(() => {
    setMenuOpen(false);
    setMobileActiveItem("");
    setActiveDropdown("");
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
      if (closeTimer.current) {
        clearTimeout(closeTimer.current);
      }
    };
  }, [menuOpen]);

  return (
    <>
      <style>{`
        .pmd-navbar {
          background: #fff;
          border-bottom: 1px solid #d2d6df;
          box-sizing: border-box;
          box-shadow: 0 8px 24px rgba(17, 24, 39, 0.03);
          color: #061a49;
          font-family: "Manrope", Arial, sans-serif;
          left: 0;
          position: fixed;
          right: 0;
          top: 0;
          overflow: visible;
          z-index: 50;
        }

        .pmd-nav-shell {
          align-items: center;
          display: flex;
          gap: 0;
          height: 80px;
          margin: 0 auto;
          max-width: 1604px;
          padding: 0 clamp(24px, 7.9vw, 152px);
          position: relative;
        }

                .pmd-logo {
          flex: 0 0 auto;
          display: flex;
          align-items: center;
        }

        .pmd-logo img {
          display: block;
          height: 24px;
          width: auto;
          margin-left:30px;
        }


        .pmd-desktop {
          align-items: center;
          display: flex;
          gap: 0;
          height: 100%;
          min-width: 0;
          flex: 1 1 auto;
        }

        .pmd-tabs {
          align-items: center;
          display: flex;
          gap: 20px;
          height: 100%;
          justify-content: center;
          min-width: 0;
          overflow-x: auto;
          flex: 1 1 auto;
          padding-right: 50px;
        }

        .pmd-tabs::-webkit-scrollbar {
          display: none;
        }

        .pmd-tab {
          align-items: center;
          background: transparent;
          border: 0;
          color: #061a49;
          cursor: pointer;
          display: inline-flex;
          font: 700 14px/1 "Manrope", Arial, sans-serif;
          gap: 5px;
          height: 100%;
          padding: 0 0 2px;
          position: relative;
          white-space: nowrap;
          flex-shrink: 0;
        }

        .pmd-tab::after {
          background: transparent;
          bottom: 0;
          content: "";
          height: 6px;
          left: 0;
          position: absolute;
          right: 0;
        }

        .pmd-tab.is-active::after {
          background: #ff4b14;
        }

        .pmd-employee:hover,
        .pmd-login:hover,
        .pmd-search:hover {
          color: #ff4b14;
        }

        .pmd-tab.is-active {
          color: #061a49;
        }

        .pmd-chevron,
        .pmd-external-icon,
        .pmd-search-icon {
          fill: none;
          stroke: currentColor;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-width: 2.1;
        }

        .pmd-chevron {
          height: 14px;
          transition: transform 160ms ease;
          width: 14px;
        }

        .pmd-chevron.is-open {
          transform: rotate(180deg);
        }

        .pmd-divider {
          background: #cbd1dc;
          height: 56px;
          width: 1px;
          flex: 0 0 1px;
        }

        .pmd-actions {
          align-items: center;
          display: flex;
          gap: 30px;
          padding-left: 34px;
          white-space: nowrap;
          flex: 0 0 auto;
        }

        .pmd-employee,
        .pmd-login {
          align-items: center;
          color: #061a49;
          display: inline-flex;
          gap: 5px;
          text-decoration: none;
        }

        .pmd-employee {
          font-size: 14px;
          font-weight: 700;
        }

        .pmd-login {
          font-size: 14px;
          font-weight: 300;
        }

        .pmd-external-icon {
          height: 15px;
          width: 15px;
        }

        .pmd-search {
          background: transparent;
          border: 0;
          color: #061a49;
          cursor: pointer;
          display: grid;
          padding: 0;
          place-items: center;
        }

        .pmd-search-icon {
          height: 30px;
          width: 25px;
          margin-left:34px;
        }
      @media (min-width: 768px) and (max-width: 1023px) {
  .pmd-search-icon {
    height: 40px;
    width: 35px;
    margin-left: 415px;
  }
}

        .pmd-search-overlay {
          background: #fff;
          bottom: auto;
          display: block;
          left: 0;
          position: absolute;
          right: 0;
          top: 100%;
          z-index: 49;
          padding: 18px 0 24px;
          border-top: 1px solid #d2d6df;
        }

        .pmd-search-overlay > div {
          margin: 0 auto;
          max-width: 1080px;
          padding: 0 24px;
        }

        .pmd-search-panel {
          background: #fff;
          border: 1px solid #cbd1dc;
          border-radius: 999px;
          display: flex;
          gap: 16px;
          width: 100%;
          padding: 12px 18px;
          align-items: center;
        }

        .pmd-search-input {
          background: transparent;
          border: 0;
          color: #061a49;
          flex: 1 1 auto;
          font-size: 16px;
          line-height: 24px;
          outline: none;
          padding: 14px 0;
          min-width: 0;
        }

        .pmd-search-input::placeholder {
          color: #7b85a0;
        }

        .pmd-search-close {
          background: transparent;
          border: 0;
          color: #061a49;
          cursor: pointer;
          font-size: 24px;
          line-height: 1;
          padding: 4px;
        }

        .pmd-search-close:hover {
          color: #ff4b14;
        }

        .pmd-search-meta {
          margin: 14px auto 0;
          max-width: 1080px;
          width: 100%;
          text-align: center;
          color: #7b85a0;
          font-size: 13px;
          line-height: 1.6;
        }

        .pmd-search-suggestions {
          margin: 24px auto 0;
          max-width: 960px;
          width: 100%;
          text-align: center;
        }

        .pmd-search-suggestions strong {
          color: #ff4b14;
          display: block;
          font-size: 14px;
          font-weight: 800;
          letter-spacing: .08em;
          margin-bottom: 14px;
          text-transform: uppercase;
        }

        .pmd-search-suggestions ul {
          display: inline-grid;
          gap: 12px;
          list-style: none;
          margin: 0;
          padding: 0;
          text-align: left;
        }

        .pmd-search-suggestions li {
          color: #061a49;
          font-size: 15px;
          line-height: 1.6;
        }

        .pmd-demo {
          height: 36px;
          width: 120px;
          display: flex;
          justify-content: center;
          align-items: center;
          background: var(--blue-color, #061a49);
          color: var(--white-color, #fff);
          padding: 16px 8px;
          border-radius: -26px;
          margin-left:40px;
          font-size: 16px;
          line-height: 16px;
          font-weight: 600;
          border: 0;
          cursor: pointer;
          transition: all ease 0.3s;
          -webkit-transition: all ease 0.3s;
          -moz-transition: all ease 0.3s;
          -ms-transition: all ease 0.3s;
          -o-transition: all ease 0.3s;
          transition-duration: 0.3s;
          transition-delay: 0s;
        }

        .pmd-mobile-actions {
          display: none;
          justify-content: end;
        }

        .pmd-menu-toggle {
          background: transparent;
          border: 0;
          color: #061a49;
          letter-spacing: .12em;
          text-transform: uppercase;
          height: 40px;
          width: 40px;

          
        }

        .pmd-mega {
          font-family: "Manrope", Arial, sans-serif;
          left: 0;
          position: fixed;
          right: 0;
          top: 80px;
          z-index: 49;
        }

        .pmd-mega-inner {
          background: #fff;
          border-top: 1px solid #d2d6df;
          box-shadow: 0 24px 64px rgba(17, 24, 39, 0.08);
          display: grid;
          grid-template-columns: 390px minmax(0, 1fr) 430px;
          grid-template-rows: auto 70px;
          margin: 0 auto;
          max-height: calc(100vh - 80px);
          max-width: 1510px;
          overflow-y: auto;
        }

        .pmd-left-col,
        .pmd-middle-col,
        .pmd-resource-col {
          padding-top: 34px;
        }

        .pmd-left-col {
          padding-left: 38px;
          padding-right: 36px;
        }

        .pmd-middle-col {
          border-left: 1px solid #d2d6df;
          padding-left: 46px;
          padding-right: 48px;
        }

        .pmd-resource-col {
          background: #f7f7f8;
          border-left: 1px solid #d2d6df;
          grid-column: 3;
          grid-row: 1 / span 2;
          padding-left: 36px;
          padding-right: 36px;
        }

        .pmd-column-title {
          border-bottom: 1px solid #cbd1dc;
          color: #3f4659;
          font-size: 14px;
          font-weight: 800;
          letter-spacing: .06em;
          line-height: 1;
          padding-bottom: 15px;
          text-transform: uppercase;
        }

        .pmd-feature-card {
          background: #f7f7f8;
          border-radius: 4px;
          margin-top: 32px;
          padding: 18px 16px;
        }

        .pmd-feature-card .pmd-platform-row + .pmd-platform-row {
          margin-top: 20px;
        }

        .pmd-platform-list {
          margin-top: 23px;
        }

        .pmd-platform-row {
          color: #061a49;
          display: block;
          text-decoration: none;
        }

        .pmd-platform-list .pmd-platform-row + .pmd-platform-row {
          margin-top: 20px;
        }

        .pmd-row-heading {
          align-items: center;
          display: flex;
          gap: 14px;
        }

        .pmd-platform-icon {
          color: #061a49;
          flex: 0 0 auto;
          height: 26px;
          width: 26px;
        }

        .pmd-row-heading span {
          color: #061a49;
          font-size: 16px;
          font-weight: 800;
          line-height: 1.1;
        }

        .pmd-row-heading span.is-active {
          color: #ff4b14;
        }

        .pmd-row-heading b {
          background: #e7370d;
          border-radius: 999px;
          color: #fff;
          font-size: 12px;
          font-weight: 800;
          line-height: 1;
          padding: 5px 9px;
        }

        .pmd-platform-row p {
          color: #061a49;
          font-size: 13px;
          line-height: 1.48;
          margin: 8px 0 0;
        }

        .pmd-initiative-list {
          margin-top: 36px;
        }

        .pmd-initiative {
          color: #061a49;
          display: block;
          text-decoration: none;
        }

        .pmd-initiative + .pmd-initiative {
          margin-top: 22px;
        }

        .pmd-initiative strong {
          display: block;
          font-size: 16px;
          font-weight: 800;
          line-height: 1.18;
        }

        .pmd-initiative:hover strong,
        .pmd-initiative:hover span,
        .pmd-integrations a:hover,
        .pmd-platform-row:hover .pmd-row-heading span {
          color: #ff4b14;
        }

        .pmd-initiative span {
          display: block;
          font-size: 13px;
          line-height: 1.45;
          margin-top: 7px;
          max-width: 620px;
        }

        .pmd-resource-list {
          display: grid;
          gap: 20px;
          margin-top: 32px;
        }

        .pmd-resource-card {
          align-items: center;
          background: #fff;
          border: 1px solid #ccd2dd;
          border-radius: 4px;
          color: #061a49;
          display: grid;
          gap: 16px;
          grid-template-columns: 104px minmax(0, 1fr);
          min-height: 124px;
          padding: 10px;
          text-decoration: none;
          transition: border-color 160ms ease, box-shadow 160ms ease;
        }

        .pmd-resource-card:hover {
          border-color: #061a49;
          box-shadow: 0 8px 18px rgba(6, 26, 73, .08);
        }

        .pmd-resource-card:hover .pmd-resource-title {
          color: #ff4b14;
        }

        .pmd-resource-image {
          background: #eef2ff;
          border-radius: 9px;
          height: 104px;
          overflow: hidden;
          width: 104px;
        }

        .pmd-resource-image img {
          display: block;
          height: 100%;
          object-fit: cover;
          width: 100%;
        }

        .pmd-education-thumb {
          background: #23aebc;
          height: 100%;
          overflow: hidden;
          position: relative;
          width: 100%;
        }

        .pmd-education-thumb::before {
          background: #ffefe0;
          border-radius: 50%;
          content: "";
          height: 88px;
          position: absolute;
          right: -22px;
          top: -24px;
          width: 88px;
        }

        .pmd-education-thumb::after {
          background: #ff4b14;
          border-radius: 999px 999px 0 0;
          bottom: -11px;
          content: "";
          height: 62px;
          left: 39px;
          position: absolute;
          width: 46px;
        }

        .pmd-edu-phone {
          background: #ff5b2d;
          border: 4px solid #224cbb;
          border-radius: 8px;
          height: 40px;
          left: 10px;
          position: absolute;
          top: 28px;
          transform: rotate(8deg);
          width: 26px;
          z-index: 2;
        }

        .pmd-edu-phone::after {
          background: #fff;
          border-radius: 50%;
          content: "";
          height: 9px;
          left: 5px;
          position: absolute;
          top: 12px;
          width: 9px;
        }

        .pmd-edu-face {
          background: #ffc1b7;
          border-radius: 50%;
          height: 28px;
          left: 58px;
          position: absolute;
          top: 25px;
          width: 28px;
          z-index: 3;
        }

        .pmd-edu-face::before {
          background: #061a49;
          border-radius: 50% 50% 45% 45%;
          content: "";
          height: 31px;
          left: -2px;
          position: absolute;
          top: -8px;
          width: 22px;
        }

        .pmd-edu-body {
          background: #fff1e8;
          border-radius: 14px 14px 0 0;
          bottom: -10px;
          height: 65px;
          left: 45px;
          position: absolute;
          width: 60px;
          z-index: 2;
        }

        .pmd-edu-body::before {
          background-image: radial-gradient(#ff4b14 4px, transparent 4px);
          background-size: 17px 17px;
          content: "";
          inset: 7px;
          position: absolute;
        }

        .pmd-edu-card {
          background: #d3ebef;
          border-radius: 8px;
          bottom: 18px;
          height: 34px;
          left: 34px;
          position: absolute;
          transform: rotate(-15deg);
          width: 38px;
          z-index: 4;
        }

        .pmd-case-thumb {
          background: #e8eefc;
          height: 100%;
          overflow: hidden;
          padding: 12px 13px;
          position: relative;
          width: 100%;
        }

        .pmd-case-top {
          align-items: center;
          background: #061a49;
          border-radius: 0 0 50% 50%;
          color: #ff4b14;
          display: flex;
          font-size: 5px;
          font-weight: 800;
          height: 31px;
          justify-content: center;
          left: 12px;
          letter-spacing: .02em;
          position: absolute;
          right: 12px;
          text-transform: lowercase;
          top: 10px;
        }

        .pmd-case-top::after {
          color: #fff;
          content: "  ";
          white-space: pre;
        }

        .pmd-case-title {
          color: #061a49;
          font-family: "Cormorant Garamond", Georgia, serif;
          font-size: 26px;
          font-weight: 600;
          left: 18px;
          line-height: .88;
          position: absolute;
          top: 49px;
        }

        .pmd-case-title span {
          color: #ff4b14;
        }

        .pmd-case-thumb::after {
          background: #061a49;
          border-radius: 999px;
          bottom: 9px;
          content: "";
          height: 2px;
          left: 22px;
          opacity: .18;
          position: absolute;
          width: 54px;
        }

        .pmd-resource-type {
          color: #3f4659;
          font-size: 13px;
          font-weight: 800;
          letter-spacing: .06em;
          line-height: 1.1;
          text-transform: uppercase;
        }

        .pmd-resource-title {
          color: #061a49;
          font-size: 15px;
          font-weight: 800;
          line-height: 1.42;
          margin-top: 10px;
        }

        .pmd-calculator-thumb {
          align-items: center;
          background: #f7f9fc;
          display: flex;
          height: 100%;
          justify-content: center;
          width: 100%;
        }

        .pmd-calculator-paper {
          background: #fff;
          border: 5px solid #2b62bd;
          border-radius: 3px;
          height: 96px;
          padding: 8px;
          width: 82px;
        }

        .pmd-calc-title,
        .pmd-calc-foot {
          background: #061a49;
          border-radius: 999px;
          display: block;
          height: 4px;
        }

        .pmd-calc-title {
          background: #ff4b14;
          height: 5px;
          margin-bottom: 8px;
          width: 54px;
        }

        .pmd-calc-row {
          display: block;
          margin-bottom: 7px;
        }

        .pmd-calc-row i,
        .pmd-calc-row b {
          border-radius: 999px;
          display: block;
          height: 3px;
        }

        .pmd-calc-row i {
          background: rgba(6, 26, 73, .22);
          margin-bottom: 3px;
          width: 58px;
        }

        .pmd-calc-row b {
          background: #ffb49d;
          position: relative;
          width: 62px;
        }

        .pmd-calc-row b::after {
          background: #ff4b14;
          border-radius: 50%;
          content: "";
          height: 7px;
          left: 18px;
          position: absolute;
          top: -2px;
          width: 7px;
        }

        .pmd-calc-foot {
          width: 35px;
        }

        .pmd-integrations {
          background: #f7f7f8;
          border-top: 1px solid #e3e6ed;
          grid-column: 1 / span 2;
          padding: 16px 38px;
        }

        .pmd-integrations a {
          color: #061a49;
          display: inline-flex;
          font-size: 14px;
          font-weight: 800;
          gap: 6px;
          line-height: 1;
          text-decoration: none;
        }

        .pmd-integrations p {
          color: #061a49;
          font-size: 13px;
          line-height: 1.4;
          margin: 6px 0 0;
        }

        .pmd-general-inner {
          background: #fff;
          border-top: 1px solid #d2d6df;
          box-shadow: 0 24px 64px rgba(17, 24, 39, 0.08);
          display: grid;
          grid-template-columns: 436px minmax(0, 1fr) 506px;
          grid-template-rows: auto 90px;
          margin: 0 auto;
          max-height: calc(100vh - 80px);
          max-width: 1604px;
          overflow-y: auto;
        }

        .pmd-general-overview {
          padding: 22px 51px 0;
        }

        .pmd-mega-close-line {
          align-items: center;
          display: flex;
          justify-content: space-between;
          margin-bottom: 24px;
        }

        .pmd-mega-close-line span {
          color: #061a49;
          font-size: 18px;
          font-weight: 800;
        }

        .pmd-mega-close-line button {
          background: transparent;
          border: 1px solid #ccd2dd;
          border-radius: 999px;
          color: #061a49;
          cursor: pointer;
          font: 700 13px/1 "Manrope", Arial, sans-serif;
          letter-spacing: .08em;
          padding: 10px 16px;
          text-transform: uppercase;
          transition: border-color 160ms ease, color 160ms ease, background 160ms ease;
        }

        .pmd-mega-close-line button:hover {
          background: #061a49;
          border-color: #061a49;
          color: #fff;
        }

        .pmd-mega-title {
          color: #061a49;
          display: inline-block;
          font-size: 18px;
          font-weight: 800;
          line-height: 1.2;
          text-decoration: none;
          transition: color 160ms ease;
        }

        .pmd-mega-title:hover,
        .pmd-general-overview:hover .pmd-mega-title {
          color: #ff4b14;
        }

        .pmd-general-overview h3,
        .pmd-general-list h3 {
          color: #061a49;
          font-size: 18px;
          font-weight: 800;
          line-height: 1.2;
          margin: 0;
        }

        .pmd-general-overview p,
        .pmd-general-list p {
          color: #061a49;
          font-size: 14px;
          line-height: 1.45;
          margin: 9px 0 0;
        }

        .pmd-quick-links {
          display: grid;
          gap: 28px;
          margin-top: 32px;
        }

        .pmd-quick-links a {
          color: #061a49;
          display: block;
          text-decoration: none;
        }

        .pmd-quick-links strong {
          display: block;
          font-size: 18px;
          font-weight: 800;
          line-height: 1.2;
        }

        .pmd-quick-links span {
          display: block;
          font-size: 14px;
          line-height: 1.45;
          margin-top: 8px;
        }

        .pmd-quick-links a:hover strong,
        .pmd-quick-links a:hover span {
          color: #ff4b14;
        }

        .pmd-general-list {
          border-left: 1px solid #d2d6df;
          padding: 22px 50px 0;
        }

        .pmd-general-list h3 {
          margin-top: 38px;
        }

        .pmd-general-grid {
          display: grid;
          gap: 30px 48px;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          margin-top: 36px;
        }

        .pmd-general-grid a {
          color: #061a49;
          font-size: 18px;
          font-weight: 800;
          line-height: 1.2;
          text-decoration: none;
          transition: color 160ms ease;
        }

        .pmd-general-grid a:hover {
          color: #ff4b14;
        }

        .pmd-general-resources {
          grid-column: 3;
          grid-row: 1 / span 2;
        }

        .pmd-general-cta {
          align-items: center;
          background: #f7f7f8;
          border-top: 1px solid #e3e6ed;
          display: flex;
          gap: 22px;
          grid-column: 1 / span 2;
          padding: 18px 51px;
        }

        .pmd-general-cta span {
          color: #061a49;
          font-size: 16px;
          line-height: 1;
        }

        .pmd-general-cta button {
          background: #061a49;
          border: 0;
          border-radius: 999px;
          color: #fff;
          cursor: pointer;
          font: 800 15px/1 "Manrope", Arial, sans-serif;
          padding: 14px 30px;
        }

        .pmd-resources-inner {
          background: #fff;
          border-top: 1px solid #d2d6df;
          box-shadow: 0 24px 64px rgba(17, 24, 39, 0.08);
          display: grid;
          grid-template-columns: minmax(0, 2.25fr) 360px 506px;
          grid-template-rows: auto 82px;
          margin: 0 auto;
          max-height: calc(100vh - 80px);
          max-width: 1604px;
          min-height: 540px;
          overflow-y: auto;
        }

        .pmd-resources-learn {
          padding: 28px 60px 0;
        }

        .pmd-resources-company {
          border-left: 0;
          padding: 28px 42px 0;
        }

        .pmd-resources-learn .pmd-column-title,
        .pmd-resources-company .pmd-column-title,
        .pmd-resources-featured .pmd-column-title {
          border-bottom: 1px solid #cbd1dc;
          color: #3f4659;
          font-size: 15px;
          letter-spacing: .08em;
          padding-bottom: 9px;
        }

        .pmd-resources-learn-grid {
          display: grid;
          gap: 48px;
          grid-template-columns: 134px minmax(0, 1fr);
          margin-top: 42px;
        }

        .pmd-resources-link-list {
          display: grid;
          gap: 25px;
        }

        .pmd-resources-link-list a {
          color: #061a49;
          font-size: 16px;
          font-weight: 800;
          line-height: 1.2;
          text-decoration: none;
          transition: color 160ms ease;
        }

        .pmd-resources-link-list a:hover,
        .pmd-resource-program:hover strong,
        .pmd-resource-program:hover em,
        .pmd-resources-card:hover strong,
        .pmd-resources-cta a:hover {
          color: #ff4b14;
        }

        .pmd-resources-programs {
          display: grid;
          gap: 30px;
        }

        .pmd-resource-program {
          align-items: flex-start;
          color: #061a49;
          display: grid;
          gap: 15px;
          grid-template-columns: 32px minmax(0, 1fr);
          text-decoration: none;
        }

        .pmd-resource-learn-icon {
          color: #061a49;
          fill: none;
          height: 32px;
          stroke: currentColor;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-width: 2;
          width: 32px;
        }

        .pmd-resource-learn-icon .pmd-icon-accent-fill {
          fill: #ff4b14;
          stroke: #ff4b14;
        }

        .pmd-resource-learn-icon circle:nth-of-type(2) {
          fill: #ff4b14;
          stroke: #ff4b14;
        }

        .pmd-resource-program strong {
          color: #061a49;
          display: block;
          font-size: 16px;
          font-weight: 800;
          line-height: 1.25;
          transition: color 160ms ease;
        }

        .pmd-resource-program em {
          color: #061a49;
          display: block;
          font-size: 13px;
          font-style: normal;
          line-height: 1.45;
          margin-top: 10px;
          transition: color 160ms ease;
        }

        .pmd-resources-company .pmd-resources-link-list {
          margin-top: 42px;
        }

        .pmd-resources-featured {
          background: #f7f7f8;
          border-left: 1px solid #d2d6df;
          grid-column: 3;
          grid-row: 1 / span 2;
          padding: 28px 42px 28px;
        }

        .pmd-resources-card-list {
          display: grid;
          gap: 24px;
          margin-top: 40px;
        }

        .pmd-resources-card {
          align-items: center;
          background: #fff;
          border: 1px solid #cbd1dc;
          border-radius: 4px;
          color: #061a49;
          display: grid;
          gap: 18px;
          grid-template-columns: 124px minmax(0, 1fr);
          min-height: 104px;
          padding: 10px;
          text-decoration: none;
          transition: border-color 160ms ease, box-shadow 160ms ease;
        }

        .pmd-resources-card:hover {
          border-color: #061a49;
          box-shadow: 0 8px 18px rgba(6, 26, 73, .08);
        }

        .pmd-resources-card-image {
          border-radius: 8px;
          display: block;
          height: 94px;
          overflow: hidden;
          width: 124px;
        }

        .pmd-resources-card-image img {
          display: block;
          height: 100%;
          object-fit: cover;
          width: 100%;
        }

        .pmd-resources-card-image .pmd-calculator-thumb {
          background: #f8fafc;
        }

        .pmd-resources-card-copy em {
          color: #3f4659;
          display: block;
          font-size: 14px;
          font-style: normal;
          font-weight: 800;
          letter-spacing: .06em;
          line-height: 1.1;
          text-transform: uppercase;
        }

        .pmd-resources-card-copy strong {
          color: #061a49;
          display: block;
          font-size: 16px;
          font-weight: 800;
          line-height: 1.35;
          margin-top: 10px;
          transition: color 160ms ease;
        }

        .pmd-paycheck-thumb {
          background: linear-gradient(135deg, #ff9d0a 0%, #ff3a13 100%);
          display: block;
          height: 100%;
          position: relative;
          width: 100%;
        }

        .pmd-paycheck-thumb > span {
          background: #fff;
          border: 4px solid #2563b8;
          bottom: 28px;
          left: 12px;
          position: absolute;
          right: 12px;
          top: 38px;
        }

        .pmd-paycheck-thumb > span::before {
          background: #ff4b14;
          content: "";
          height: 5px;
          left: 8px;
          position: absolute;
          right: 8px;
          top: 7px;
        }

        .pmd-paycheck-thumb i {
          background: #ffb5d2;
          bottom: 41px;
          height: 6px;
          left: 22px;
          position: absolute;
          width: 44px;
        }

        .pmd-paycheck-thumb b {
          background: #ff4b14;
          border-radius: 50%;
          bottom: 39px;
          height: 15px;
          position: absolute;
          right: 20px;
          width: 15px;
        }

        .pmd-resources-cta {
          background: #f7f7f8;
          grid-column: 1 / span 2;
          padding: 22px 60px 0;
        }

        .pmd-resources-cta a {
          color: #061a49;
          display: inline-flex;
          font-size: 14px;
          font-weight: 800;
          gap: 7px;
          line-height: 1.1;
          text-decoration: none;
          transition: color 160ms ease;
        }

        .pmd-resources-cta p {
          color: #061a49;
          font-size: 13px;
          line-height: 1.45;
          margin: 7px 0 0;
        }

        .pmd-partners-inner {
          background: #fff;
          border-top: 1px solid #d2d6df;
          box-shadow: 0 24px 64px rgba(17, 24, 39, 0.08);
          display: grid;
          grid-template-columns: 430px minmax(0, 1fr) 506px;
          margin: 0 auto;
          max-height: calc(100vh - 80px);
          max-width: 1604px;
          min-height: 440px;
          overflow-y: auto;
        }

        .pmd-partners-left {
          padding: 22px 51px 0;
        }

        .pmd-partners-overview {
          color: #061a49;
          display: block;
          text-decoration: none;
          transition: color 160ms ease;
        }

        .pmd-partners-left h3,
        .pmd-built-in strong {
          color: #061a49;
          display: block;
          font-size: 18px;
          font-weight: 800;
          line-height: 1.2;
          margin: 0;
        }

        .pmd-partners-left p,
        .pmd-built-in span {
          color: #061a49;
          display: block;
          font-size: 14px;
          line-height: 1.45;
          margin-top: 9px;
          max-width: 360px;
        }

        .pmd-partners-overview:hover {
          color: #ff4b14;
        }

        .pmd-partners-overview:hover h3,
        .pmd-partners-overview:hover p {
          color: #ff4b14;
        }

        .pmd-partner-links {
          display: grid;
          gap: 31px;
          margin-top: 31px;
        }

        .pmd-partner-links a,
        .pmd-built-in {
          color: #061a49;
          text-decoration: none;
        }

        .pmd-partner-links a {
          font-size: 18px;
          font-weight: 800;
          line-height: 1.2;
          transition: color 160ms ease;
        }

        .pmd-partner-links a:hover,
        .pmd-built-in:hover strong,
        .pmd-built-in:hover span,
        .pmd-featured-partner-card:hover > strong {
          color: #ff4b14;
        }

        .pmd-partners-middle {
          border-left: 1px solid #d2d6df;
          padding: 22px 53px 0;
        }

        .pmd-built-in sup {
          font-size: 9px;
          line-height: 0;
          margin-left: 2px;
          vertical-align: super;
        }

        .pmd-built-in b {
          background: #e7370d;
          border-radius: 999px;
          color: #fff;
          display: inline-block;
          font-size: 11px;
          font-weight: 800;
          line-height: 1;
          margin-left: 5px;
          padding: 5px 8px;
          vertical-align: 1px;
        }

        .pmd-partners-featured {
          background: #f7f7f8;
          border-left: 1px solid #d2d6df;
          padding: 38px 42px 0;
        }

        .pmd-featured-partner-card {
          color: #061a49;
          display: block;
          margin-top: 42px;
          text-decoration: none;
        }

        .pmd-featured-partner-image {
          align-items: center;
          background: #061a49;
          border-radius: 14px;
          box-shadow: 0 8px 20px rgba(6, 26, 73, .08);
          display: flex;
          gap: 20px;
          height: 224px;
          justify-content: center;
          overflow: hidden;
          padding: 45px 26px;
          width: 100%;
        }

        .pmd-featured-partner-image img {
          display: block;
          max-height: 56px;
          max-width: 205px;
          object-fit: contain;
          width: auto;
        }

        .pmd-featured-partner-image > i {
          background: #fff;
          display: block;
          flex: 0 0 auto;
          height: 56px;
          opacity: .95;
          width: 2px;
        }

        .pmd-workday-badges {
          align-items: center;
          display: flex;
          flex: 0 0 auto;
          gap: 10px;
        }

        .pmd-workday-badge {
          align-items: center;
          background: #fff;
          border: 2px solid #2f71df;
          border-radius: 12px;
          color: #245eb7;
          display: flex;
          flex-direction: column;
          height: 64px;
          justify-content: center;
          overflow: hidden;
          position: relative;
          width: 64px;
        }

        .pmd-workday-badge::before {
          border: 3px solid #f4a625;
          border-bottom: 0;
          border-radius: 999px 999px 0 0;
          bottom: 13px;
          content: "";
          height: 12px;
          left: 19px;
          position: absolute;
          width: 26px;
        }

        .pmd-workday-badge strong {
          color: #245eb7;
          display: block;
          font-size: 8.5px;
          font-weight: 800;
          line-height: 1.05;
          margin: 0 0 9px;
          text-align: center;
        }

        .pmd-workday-badge em {
          color: #245eb7;
          display: block;
          font-size: 8px;
          font-style: normal;
          font-weight: 800;
          line-height: 1;
          text-align: center;
        }

        .pmd-workday-innovation {
          background: #2e6fd4;
          color: #fff;
        }

        .pmd-workday-innovation strong {
          color: #fff;
        }

        .pmd-workday-innovation em {
          background: #fff;
          border-radius: 0 0 10px 10px;
          bottom: 0;
          color: #245eb7;
          left: 0;
          padding: 6px 0 7px;
          position: absolute;
          right: 0;
        }

        .pmd-featured-partner-card > strong {
          color: #061a49;
          display: block;
          font-size: 18px;
          font-weight: 800;
          line-height: 1.42;
          margin-top: 30px;
          max-width: 430px;
          transition: color 160ms ease;
        }

        .pmd-mobile-menu {
          display: none;
        }

        .pmd-navbar-spacer {
          display: none;
        }

        .pmd-mobile-backdrop {
          background: rgba(6, 26, 73, 0.34);
          bottom: 0;
          left: 0;
          position: fixed;
          right: 0;
          top: 0;
          z-index: 80;
        }

        .pmd-mobile-backdrop::after {
          background: rgba(6, 26, 73, 0.16);
          bottom: 0;
          content: "";
          left: min(430px, 88vw);
          position: absolute;
          top: 0;
          width: 120px;
        }

        .pmd-mobile-menu {
          background: #fff;
          box-shadow: 18px 0 42px rgba(6, 26, 73, 0.18);
          color: #290001;
          display: flex;
          flex-direction: column;
          font-family: "Manrope", Arial, sans-serif;
          height: 100vh;
          left: 0;
          max-width: 430px;
          position: fixed;
          top: 0;
          width: min(88vw, 430px);
          z-index: 81;
        }

        .pmd-mobile-menu-head {
          align-items: center;
          background: #fff;
          display: flex;
          flex: 0 0 auto;
          justify-content: space-between;
          min-height: 88px;
          padding: 18px 28px 16px;
        }

        .pmd-mobile-drawer-logo {
          align-items: center;
          display: flex;
          text-decoration: none;
        }

        .pmd-mobile-drawer-logo img {
          height: 36px;
          object-fit: contain;
          width: auto;
        }

        .pmd-mobile-close,
        .pmd-menu-toggle {
          align-items: center;
          background: transparent;
          border: 0;
          color: #290001;
          cursor: pointer;
          display: inline-flex;
          justify-content: center;
          padding: 0;
        }

        .pmd-mobile-close {
          height: 42px;
          width: 42px;
        }

        .pmd-mobile-close-icon,
        .pmd-mobile-menu-icon {
          fill: none;
          stroke: currentColor;
          stroke-linecap: round;
          stroke-linejoin: round;
        }

        .pmd-mobile-close-icon {
          height: 32px;
          stroke-width: 2.4;
          width: 32px;
        }

        .pmd-mobile-menu-icon {
          height: 28px;
          stroke-width: 2.5;
          width: 28px;
        }

        .pmd-mobile-menu-scroll {
          flex: 1 1 auto;
          overflow-y: auto;
          padding-bottom: 102px;
        }

        .pmd-mobile-section {
          border-top: 1px solid #edf0f4;
        }

        .pmd-mobile-section:first-child {
          border-top: 0;
        }

        .pmd-mobile-accordion {
          align-items: center;
          background: #fff;
          border: 0;
          color: #290001;
          cursor: pointer;
          display: flex;
          font: 700 16px/1.2 "Manrope", Arial, sans-serif;
          justify-content: space-between;
          padding: 19px 30px;
          text-align: left;
          width: 100%;
        }

        .pmd-mobile-accordion.is-open {
          background: #fff1e7;
          font-weight: 800;
        }

        .pmd-mobile-accordion .pmd-chevron {
          color: #290001;
          height: 18px;
          stroke-width: 2.6;
          width: 18px;
        }

        .pmd-mobile-panel {
          background: #fff;
          padding: 20px 28px 24px;
        }

        .pmd-mobile-panel a {
          color: #1f1113;
          display: block;
          font-size: 16px;
          font-weight: 800;
          line-height: 1.35;
          padding: 13px 10px;
          text-decoration: none;
        }

        .pmd-mobile-panel a.is-orange,
        .pmd-mobile-panel .is-orange {
          color: #c83b0b;
        }

        .pmd-mobile-panel b {
          background: #c83b0b;
          border-radius: 999px;
          color: #fff;
          display: inline-block;
          font-size: 10px;
          font-weight: 900;
          line-height: 1;
          margin-left: 6px;
          padding: 4px 7px;
          vertical-align: middle;
        }

        .pmd-mobile-title {
          border-bottom: 1px solid #d9d9d9;
          color: #1f1113;
          font-size: 14px;
          font-weight: 900;
          letter-spacing: .07em;
          line-height: 1;
          margin: 8px 0 15px;
          padding: 0 0 15px;
          text-transform: uppercase;
        }

        .pmd-mobile-feature-card {
          background: #fff1e7;
          border-radius: 4px;
          margin-bottom: 9px;
          padding: 7px 0;
        }

        .pmd-mobile-icon-row {
          align-items: center;
          display: flex !important;
          gap: 12px;
        }

        .pmd-mobile-icon-row .pmd-platform-icon {
          flex: 0 0 28px;
          height: 28px;
          width: 28px;
        }

        .pmd-mobile-featured {
          background: #fff1e7;
          margin: 18px -28px -24px;
          padding: 24px 28px;
        }

        .pmd-mobile-featured-flush {
          margin-top: 22px;
        }

        .pmd-mobile-resource-card {
          align-items: stretch;
          background: #fff;
          border: 1px solid #ded8d4;
          border-radius: 3px;
          box-shadow: 0 1px 3px rgba(41, 0, 1, 0.08);
          display: grid !important;
          gap: 12px;
          grid-template-columns: 84px minmax(0, 1fr);
          margin-top: 8px;
          min-height: 104px;
          padding: 8px !important;
        }

        .pmd-mobile-resource-image {
          align-items: center;
          background: #f5f5f5;
          display: flex;
          justify-content: center;
          min-height: 88px;
          overflow: hidden;
        }

        .pmd-mobile-resource-image img {
          height: 100%;
          object-fit: cover;
          width: 100%;
        }

        .pmd-mobile-resource-card span {
          color: #1f1113;
          display: block;
          font-size: 12px;
          font-weight: 900;
          letter-spacing: .08em;
          line-height: 1.05;
          margin-bottom: 7px;
          text-transform: uppercase;
        }

        .pmd-mobile-resource-card strong {
          color: #1f1113;
          display: block;
          font-size: 16px;
          font-weight: 900;
          line-height: 1.26;
        }

        .pmd-mobile-workday-card {
          display: block !important;
          padding: 0 !important;
        }

        .pmd-mobile-workday-card .pmd-featured-partner-image {
          border-radius: 7px;
          height: 126px;
          margin: 0;
          padding: 25px 18px;
        }

        .pmd-mobile-workday-card .pmd-featured-partner-image img {
          max-height: 40px;
          max-width: 118px;
        }

        .pmd-mobile-workday-card .pmd-workday-badge {
          height: 46px;
          width: 46px;
        }

        .pmd-mobile-workday-card .pmd-workday-badge strong,
        .pmd-mobile-workday-card .pmd-workday-badge em {
          font-size: 6px;
        }

        .pmd-mobile-workday-card > strong {
          color: #c83b0b;
          display: block;
          font-size: 16px;
          font-weight: 900;
          line-height: 1.38;
          margin-top: 18px;
        }

        .pmd-mobile-employee-box {
          background: #fff1e7;
          padding: 22px 28px 24px;
        }

        .pmd-mobile-employee-box > strong {
          color: #290001;
          display: block;
          font-size: 16px;
          font-weight: 900;
          margin-bottom: 12px;
        }

        .pmd-mobile-employee-box p {
          color: #290001;
          font-size: 16px;
          line-height: 1.4;
          margin: 0 0 15px;
        }

        .pmd-mobile-employee-box div {
          display: grid;
          gap: 8px;
          grid-template-columns: 1fr 1fr;
        }

        .pmd-mobile-employee-box a {
          align-items: center;
          background: transparent;
          border: 1px solid #d8d1cd;
          color: #290001;
          display: flex;
          font-size: 15px;
          font-weight: 900;
          justify-content: center;
          min-height: 38px;
          text-decoration: none;
        }

        .pmd-mobile-employee-box a + a {
          background: #3b0000;
          border-color: #8d6868;
          color: #fff;
        }

        .pmd-mobile-demo-bar {
          background: #fff;
          border-top: 1px solid #e4e4e4;
          bottom: 0;
          left: 0;
          padding: 12px 22px;
          position: absolute;
          right: 0;
        }

        .pmd-mobile-demo-bar a {
          align-items: center;
          background: #3b0000;
          color: #fff;
          display: flex;
          font-size: 16px;
          font-weight: 900;
          justify-content: center;
          min-height: 42px;
          text-decoration: none;
        }

        @media (max-width: 1360px) {
          .pmd-nav-shell {
            grid-template-columns: 220px minmax(0, 1fr);
            padding-left: 28px;
            padding-right: 28px;
          }

          .pmd-tabs {
            gap: 14px;
          }

          .pmd-actions {
            gap: 20px;
            padding-left: 24px;
          }

          .pmd-partners-inner {
            grid-template-columns: 390px minmax(0, 1fr) 430px;
          }

          .pmd-partners-left {
            padding-left: 38px;
            padding-right: 38px;
          }

          .pmd-featured-partner-image {
            gap: 18px;
            height: 178px;
            padding: 34px 24px;
          }

          .pmd-featured-partner-image img {
            max-height: 56px;
            max-width: 170px;
          }

          .pmd-workday-badge {
            height: 58px;
            width: 58px;
          }

          .pmd-resources-inner {
            grid-template-columns: minmax(0, 2fr) 320px 430px;
            min-height: 520px;
          }

          .pmd-resources-learn {
            padding-left: 38px;
            padding-right: 38px;
          }

          .pmd-resources-featured {
            padding-left: 36px;
            padding-right: 36px;
          }

          .pmd-resources-card {
            gap: 16px;
            grid-template-columns: 104px minmax(0, 1fr);
          }

          .pmd-resources-card-image {
            width: 104px;
          }
        }

        @media (max-width: 1199px) {
          .pmd-desktop,
          .pmd-mega {
            display: none;
          }

          .pmd-nav-shell {
            grid-template-columns: auto minmax(0, 1fr);
          }

          .pmd-mobile-actions {
            align-items: center;
            display: flex;
            gap: 18px;
          }
        }
          /* ================= MOBILE NAVBAR ================= */

.pmd-mobile-navbar {
  display: none;
}

.pmd-mobile-header {
  display: none;
}

/* ================= MOBILE & TABLET ================= */

@media (max-width: 1023px) {

  /* DESKTOP HIDE */
  .pmd-desktop {
    display: none;
  }

  .pmd-navbar {
    box-sizing: border-box;
    width: 100%;
  }

  .pmd-navbar *,
  .pmd-navbar *::before,
  .pmd-navbar *::after {
    box-sizing: border-box;
  }

  .pmd-nav-shell {
    height: auto;
    padding: 0;
  }

  .pmd-navbar-spacer {
    display: block;
    height: 58px;
  }

  .pmd-navbar-spacer.has-employee-strip {
    height: 102px;
  }

  .pmd-mobile-header {
    background: #fff;
    display: block;
    width: 100%;
  }

  .pmd-employee-strip {
    align-items: center;
    background: #fff1e7;
    color: #290001;
    display: flex;
    font-size: 11px;
    font-weight: 700;
    justify-content: space-between;
    line-height: 1.2;
    min-height: 44px;
    padding: 0 10px 0 12px;
    width: 100%;
  }

  .pmd-employee-strip a {
    color: #290001;
    font-weight: 900;
    text-decoration: none;
  }

  .pmd-employee-strip button {
    align-items: center;
    background: transparent;
    border: 0;
    color: #290001;
    cursor: pointer;
    display: inline-flex;
    height: 32px;
    justify-content: center;
    padding: 0;
    width: 32px;
  }

  .pmd-employee-strip .pmd-mobile-close-icon {
    height: 21px;
    stroke-width: 2.8;
    width: 21px;
  }

  /* MOBILE NAVBAR */
  .pmd-mobile-navbar {
    display: grid;
    align-items: center;
    grid-template-columns: 26px minmax(112px, 1fr) 28px 104px;
    width: 100%;
    column-gap: 8px;
    min-height: 58px;
    padding: 0 9px;
    border-bottom: 1px solid #edf0f4;
    box-shadow: 0 6px 14px rgba(17, 24, 39, 0.05);
  }

  /* MENU ICON */
  .pmd-menu-toggle {
    background: transparent;
    border: none;
    cursor: pointer;
    color: #290001;
    height: 36px;
    margin: 0;
    width: 26px;
  }

  /* MOBILE LOGO */
  .mobile-logo {
    min-width: 0;
    overflow: hidden;
  }

  .mobile-logo img {
    height: 23px;
    margin: 0;
    max-width: 112px;
    width: auto;
    object-fit: contain;
  }

  /* SEARCH BUTTON */
  .pmd-mobile-navbar .pmd-search {
    align-items: center;
    background: transparent;
    border: 0;
    cursor: pointer;
    display: inline-flex;
    height: 36px;
    justify-content: center;
    padding: 0;
    width: 28px;
  }

  .pmd-search-icon {
    background: transparent;
    border: none;
    cursor: pointer;
    height: 24px;
    margin: 0;
    width: 24px;
  }


  /* DEMO BUTTON */
  .pmd-mobile-navbar .pmd-demo {
    background: #290001;
    color: white;
    border: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 42px;
    line-height: 1;
    margin: 0;
    min-height: 42px;
    min-width: 0;
    overflow: hidden;
    padding: 0 8px;
    white-space: nowrap;
    width: 104px;
    font-size: 13px;
    font-weight: 900;
    cursor: pointer;
    border-radius: 0;
  }
   
  
}
  /* ================= TABLET ONLY ================= */

@media (min-width: 768px) and (max-width: 1023px) {

  .pmd-navbar {
    width: 100%;
    padding: 0;
  }

  /* MOBILE/TABLET NAVBAR */
  .pmd-mobile-navbar {
    display: grid;
    align-items: center;
    grid-template-columns: 34px minmax(0, 1fr) 34px 124px;
    width: 100%;
    column-gap: 16px;
    padding: 0 20px;
  }

  /* MENU ICON */
  .pmd-menu-toggle {
    background: transparent;
    border: none;
    cursor: pointer;
    color: #290001;
    margin: 0;
  }

  /* LOGO */
  .mobile-logo img {
    height: 34px;
    max-width: 180px;
    width: auto;
    object-fit: contain;
    margin: 0;
  }

  /* SEARCH ICON */
  .pmd-search-icon {
    background: transparent;
    border: none;
    cursor: pointer;
    height: 30px;
    width: 30px;
    margin: 0;
  }

  /* DEMO BUTTON */
  .pmd-mobile-navbar .pmd-demo {
    background: #290001;
    color: white;
    border: none;
    padding: 0 22px;
    width: 124px;
    font-size: 15px;
    font-weight: 900;
    cursor: pointer;
  }
}

/* ================= DESKTOP ================= */

@media (min-width: 1024px) {

  .pmd-mobile-navbar {
    display: none;
  }

  .pmd-desktop {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
}
      `}</style>

      <nav className="pmd-navbar">
  <div
    className="pmd-nav-shell"
    onMouseEnter={cancelClose}
    onMouseLeave={scheduleClose}
  >

    {/* ================= MOBILE NAVBAR ================= */}
    <div className="pmd-mobile-header">
      {employeeBarVisible && (
        <div className="pmd-employee-strip">
          <span>
            Are you an employee? <a href="/">Log in or sign up &gt;</a>
          </span>
          <button
            type="button"
            aria-label="Hide employee login message"
            onClick={() => setEmployeeBarVisible(false)}
          >
            <CloseIcon />
          </button>
        </div>
      )}

      <div className="pmd-mobile-navbar">
        {/* MENU BUTTON */}
        <button
          className="pmd-menu-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
          type="button"
          aria-label={menuOpen ? "Close menu" : "Open menu"}
        >
          {menuOpen ? <CloseIcon /> : <MenuIcon />}
        </button>

        {/* LOGO */}
        <Link className="pmd-logo mobile-logo" to="/">
          <img src={logo} alt="PayMeDaily" />
        </Link>

        {/* SEARCH */}
        <button
          className="pmd-search"
          type="button"
          aria-label="Open search"
          onClick={() => setSearchOpen(true)}
        >
          <SearchIcon />
        </button>

        {/* DEMO BUTTON */}
        <button className="pmd-demo mobile-demo" type="button">
          Get a Demo
        </button>
      </div>
    </div>

    {/* ================= DESKTOP NAVBAR ================= */}
    <div className="pmd-desktop">

      {/* DESKTOP LOGO */}
      <Link className="pmd-logo" to="/">
        <img src={logo} alt="PayMeDaily" />
      </Link>

      {/* TABS */}
      <div className="pmd-tabs">
        {navItems.map((item) => (
          <button
            className={`pmd-tab ${
              activeDropdown === item ? "is-active" : ""
            }`}
            key={item}
            onClick={() =>
              activeDropdown === item
                ? setActiveDropdown("")
                : openDropdown(item)
            }
            onMouseEnter={() => openDropdown(item)}
            type="button"
          >
            {item}
            <ChevronIcon open={activeDropdown === item} />
          </button>
        ))}

        <div className="pmd-divider" />

        <Link className="pmd-employee" to="/">
          For Employees <ExternalIcon />
        </Link>
      </div>

      {/* ACTIONS */}
      <div className="pmd-actions">

        <button
          className="pmd-search"
          type="button"
          aria-label="Open search"
          onClick={() => setSearchOpen(true)}
        >
          <SearchIcon />
        </button>

        <Link className="pmd-login" to="/">
          Log In
        </Link>

        <button className="pmd-demo" type="button">
          Get a Demo
        </button>
      </div>
    </div>

    {/* ================= SEARCH OVERLAY ================= */}
    {searchOpen && (
      <div className="pmd-search-overlay">
        <div>

          <div className="pmd-search-panel">
            <SearchIcon />

            <input
              className="pmd-search-input"
              type="text"
              value={searchQuery}
              onChange={(event) =>
                setSearchQuery(event.target.value)
              }
              placeholder="Search for industries, articles, products, solution and more"
              autoFocus
            />

            <button
              className="pmd-search-close"
              type="button"
              aria-label="Close search"
              onClick={() => setSearchOpen(false)}
            >
              ×
            </button>
          </div>

          <div className="pmd-search-meta">
            *Search queries are shared with a third-party vendor
            that powers the search function.
          </div>

          <div className="pmd-search-suggestions">
            <strong>popular searches</strong>

            <ul>
              <li>earned wage access</li>
              <li>On-Demand Pay</li>
              <li>improve employee retention</li>
              <li>employee financial wellness</li>
              <li>reduce turnover</li>
              <li>increase employee engagement</li>
            </ul>
          </div>
        </div>
      </div>
    )}
  </div>
</nav>

<div
  className={`pmd-navbar-spacer ${
    employeeBarVisible ? "has-employee-strip" : ""
  }`}
  aria-hidden="true"
/>

{/* ================= DROPDOWN MENUS ================= */}

{activeDropdown === "Solutions" && (
  <SolutionsMenu
    onMouseEnter={cancelClose}
    onMouseLeave={scheduleClose}
  />
)}

{activeDropdown === "Our Partners" && (
  <PartnersMenu
    onMouseEnter={cancelClose}
    onMouseLeave={scheduleClose}
  />
)}

{activeDropdown === "Resources" && (
  <ResourcesMenu
    onMouseEnter={cancelClose}
    onMouseLeave={scheduleClose}
  />
)}

{activeDropdown !== "Solutions" &&
  activeDropdown !== "Our Partners" &&
  activeDropdown !== "Resources" && (
    <GeneralMenu
      menu={generalMenus[activeDropdown]}
      onMouseEnter={cancelClose}
      onMouseLeave={scheduleClose}
    />
)}

{/* ================= MOBILE MENU ================= */}

{menuOpen && (
    <MobileMenu
    activeItem={mobileActiveItem}
    activeLink={mobileActiveLink}
    onLinkSelect={handleMobileLinkSelect}
    onToggle={(item) => setMobileActiveItem(mobileActiveItem === item ? "" : item)}
    onClose={closeMobileMenu}
  />
)}
    </>
  );
}

export default Navbar;
